import { render, staticRenderFns } from "./RewardDuplicateControls.vue?vue&type=template&id=0f326d65&"
import script from "./RewardDuplicateControls.vue?vue&type=script&lang=js&"
export * from "./RewardDuplicateControls.vue?vue&type=script&lang=js&"
import style0 from "./RewardDuplicateControls.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports